import moment from 'moment';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';
import Messages from '../../components/Messages';
import { clearState } from '../../localStorage';
import Api from '../../services/api';
import { getProp, __ } from '../../utilities';
import { errorAlert, loadMessages } from '../App/actions';
import { alertSelector, messagesSelector } from '../App/selectors';
import ConnectionForm from '../ConnectionForm';
import CustomForm from './CustomForm';

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.color.primary};
  height: auto;
  color: #fff;
  padding: ${rem(5)};
  ${({ theme }) => theme.media.sm`
    padding: ${rem(30)} ${rem(50)};
  `};
`;

class ExternalConnectionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        startDate: moment(),
        endDate: moment().add(1, 'week'),
      },
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(loadMessages());
  }

  handleSubmit() {
    const { values } = this.state;
    const { dispatch, lang } = this.props;
    const startDateMomentObj = moment(getProp(values, ['startDate']));
    const endDateMomentObj = moment(getProp(values, ['endDate']));
    if (getProp(values, ['stationFrom']) === '') {
      dispatch(errorAlert(__('Nezadali ste zastávku odchodu!')));
    } else if (getProp(values, ['stationTo']) === '') {
      dispatch(errorAlert(__('Nezadali ste zastávku príchodu!')));
    } else if (!startDateMomentObj || !startDateMomentObj.isValid()) {
      dispatch(errorAlert(__('Zlý formát dátumu prvej cesty!')));
    } else if (
      values.ticketType === 'R' &&
      (!endDateMomentObj || !endDateMomentObj.isValid())
    ) {
      dispatch(errorAlert(__('Zlý formát dátumu druhej cesty!')));
    } else if (
      values.ticketType === 'R' &&
      startDateMomentObj.diff(endDateMomentObj) > 0
    ) {
      dispatch(
        errorAlert(
          __(
            'Zle zadané dátumy. Dátum odchodu musí byť menší ako dátum návratu!',
          ),
        ),
      );
    } else {
      clearState();
      Api.redirect(
        `/reservation?${Api.objectToParams({
          ...values,
          startDate: startDateMomentObj.format('YYYY-MM-DD'),
          endDate: endDateMomentObj.format('YYYY-MM-DD'),
          lang,
        })}`,
      );
    }
  }

  handleFormChange(values) {
    this.setState({ values });
  }

  render() {
    const { messages } = this.props;
    return (
      <Wrapper>
        <ConnectionForm
          value={this.state.values}
          onChange={this.handleFormChange}
          onSubmit={this.handleSubmit}
          renderCustomForm={props => <CustomForm {...props} />}
        />
        <SweetAlert {...this.props.alert} />
        <Messages messages={messages} />
      </Wrapper>
    );
  }
}

ExternalConnectionForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
  alert: PropTypes.shape({}).isRequired,
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
    }),
  ).isRequired,
};

const mapStateToProps = state => {
  return {
    alert: alertSelector(state),
    messages: messagesSelector(state),
  };
};
const FormWithRouter = withRouter(ExternalConnectionForm);
export default connect(mapStateToProps)(FormWithRouter);



// WEBPACK FOOTER //
// ./src/containers/ExternalConnectionForm/index.js